import { Link, Text } from '@billy/design-system'
import { ReactElement } from 'react'

import * as Styled from './styles'

interface EInvoicingFooterProps {
  description: string
  isEmptyStatePage: boolean
  link: string
  linkDescription: string
}

export const EInvoicingFooter = ({
  description,
  isEmptyStatePage = false,
  link,
  linkDescription,
}: EInvoicingFooterProps): ReactElement => (
  <Styled.FooterContainer footerMarginTop={isEmptyStatePage ? 'lg' : 'sm'}>
    <Text alignment="center">{description}</Text>
    <Text weight="bold">
      <Link href={link} target="_blank" rel="noopener noreferrer">
        {linkDescription}
      </Link>
    </Text>
  </Styled.FooterContainer>
)
